import { createContext, ReactNode, useContext, useEffect } from 'react'

/** One action bar, same place on every screen. A screen declares it; the frame renders it. */
export interface IFooter {
   action: string
   onAction: () => void
   disabled?: boolean
   loading?: boolean
   hint?: ReactNode
   back?: (() => void) | null
   secondary?: { label: string; onClick: () => void } | null
   testId?: string
   icon?: string
}

export const FooterCtx = createContext<{ set: (f: IFooter | null) => void }>({
   set: () => undefined,
})

export const useFooter = (f: IFooter) => {
   const { set } = useContext(FooterCtx)
   const key = JSON.stringify([
      f.action,
      f.disabled,
      f.loading,
      typeof f.hint === 'string' ? f.hint : '',
      f.secondary?.label,
      Boolean(f.back),
      f.testId,
      f.icon,
   ])
   useEffect(() => {
      set(f)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [key])
   useEffect(() => () => set(null), [set])
}
